import { ListaEventoElement } from 'api/Assessor/evento';

interface TableState {
  rows: Array<ListaEventoElement>;
  page: number;
  count: number;
  totalElements: number;
}

type TableActionType = 'setRows' | 'setPage' | 'setCount' | 'setTotalElements';

interface TableAction {
  type: TableActionType;
  value: any;
}

export const tableInitialState: TableState = {
  rows: [],
  page: 1,
  count: 0,
  totalElements: 0,
};

export const tableReducer = (
  state: TableState,
  action: TableAction
): TableState => {
  switch (action.type) {
    case 'setRows':
      return { ...state, rows: action.value };
    case 'setPage':
      return { ...state, page: action.value };
    case 'setCount':
      return { ...state, count: action.value };
    case 'setTotalElements':
      return { ...state, totalElements: action.value };
    default:
      return state;
  }
};
